// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__I9Gxn","productName":"Table_productName__24Rwa"};